import { queryOptions } from '@tanstack/react-query';
import { getCategory, getProducts, getCategoryMappings, getProduct, getSmartSwaps } from './services';

export const categoriesQueryOptions = (categoryId: string) => queryOptions({
  queryKey: ['categoryList', categoryId],
  queryFn: getCategory(categoryId),
  staleTime: 1000 * 60 * 5,
});

export const productsQueryOptions = (categoryId: string, subcategory: string | undefined | null, pageNo?: number) => queryOptions({
  queryKey: ['productList', categoryId, pageNo, subcategory],
  queryFn: getProducts(categoryId, subcategory, pageNo),
  staleTime: 1000 * 60 * 5,
});

export const productQueryOptions = (productId: string) => queryOptions({
  queryKey: ['product', productId],
  queryFn: getProduct(productId),
  staleTime: 1000 * 60 * 5,
});

export const smartSwapsQueryOptions = (productId: string) => queryOptions({
  queryKey: ['smartSwaps', productId],
  queryFn: getSmartSwaps(productId),
  staleTime: 1000 * 60 * 5,
});

export const categoryMappingsQueryOptions = (subcategoryId: string) => queryOptions({
  queryKey: ['categoryMappings', subcategoryId],
  queryFn: getCategoryMappings(subcategoryId),
  staleTime: 1000 * 60 * 5,
});